export default "__VITE_ASSET__43de392b__"